/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {useAuth} from '../../../../app/modules/auth'

const HeaderUserMenu: FC = () => {
  const intl = useIntl()
  const {currentUser, logout} = useAuth()
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.first_name} {currentUser?.last_name}
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {currentUser?.phone}
            </a>
          </div>
        </div>
      </div>
      <div className='separator my-2'></div>

      <div className='menu-item px-5 my-1'>
        <Link to='/dashboard' className='menu-link px-5'>
          {intl.formatMessage({id: 'MENU.DASHBOARD'})}
        </Link>
      </div>
      <div className='menu-item px-5 my-1'>
        <Link to='/setting' className='menu-link px-5'>
          {intl.formatMessage({id: 'MENU.SETTINGS'})}
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          {intl.formatMessage({id: 'MENU.LOGOUT'})}
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
